import { render, staticRenderFns } from "./MarketingUpgrade.vue?vue&type=template&id=64f3577e&scoped=true&"
import script from "./MarketingUpgrade.vue?vue&type=script&lang=js&"
export * from "./MarketingUpgrade.vue?vue&type=script&lang=js&"
import style0 from "./MarketingUpgrade.vue?vue&type=style&index=0&id=64f3577e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64f3577e",
  null
  
)

export default component.exports